<template>
  <!-- Root wrapper: picks up id, class, style, etc. -->
  <div
    v-bind="$attrs"
    :class="['input-group', sizeClass]"
    role="group"
    v-on="$listeners"
  >
    <!-- `prepend` slot (same as b-input-group prepend) -->
    <slot name="prepend"></slot>

    <!-- default slot: your <input class="form-control"> -->
    <slot />

    <!-- `append` slot (same as b-input-group-append) -->
    <slot name="append"></slot>
  </div>
</template>

<script>
export default {
  name: "BaseInputGroup",
  inheritAttrs: false,
  props: {
    /** 'sm' or 'lg' (Bootstrap’s .input-group-sm / .input-group-lg) */
    size: {
      type: String,
      default: null,
      validator: (v) => ["sm", "lg"].includes(v),
    },
    /**
     * alignment inside a flex container:
     * - 'start' → justify-content-start
     * - 'center' → justify-content-center
     * - 'end'   → justify-content-end
     */
    align: {
      type: String,
      default: null,
      validator: (v) => ["start", "center", "end"].includes(v),
    },
  },
  computed: {
    sizeClass() {
      return this.size ? `input-group-${this.size}` : "";
    },
    alignClass() {
      if (!this.align) return "";
      return {
        start: "justify-content-start",
        center: "justify-content-center",
        end: "justify-content-end",
      }[this.align];
    },
  },
};
</script>
